import PropTypes from 'prop-types';

const TaskType = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
});

export default TaskType;



// WEBPACK FOOTER //
// ./client/app/shared/types/task.js